module.exports = __webpack_public_path__ + "media/images/talheres-f21d6c817797f0da87efb7c6ba4ff538.svg";